module.exports = __webpack_public_path__ + "static/img/img_product_zhinengshenhe@2x.a959b41.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/产品服务/img_product_zhinengshenhe@2x.png
// module id = ki5t
// module chunks = 0